import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
    selector: '[jira]'
})
export class JiraDirective {

    constructor(private el: ElementRef) { }

    @Input('jira') storyNumber: string;

    @HostListener('mousedown') onMouseDown() {
        window.open(`https://jira.research.corteva.com/browse/${this.storyNumber.toUpperCase()}`, '_new');
    }
}
